import { graphql, type ResultOf } from '@teachino/shared-infrastructure';

export const generateLinkPreviewMutation = graphql(`
  mutation GenerateLinkPreview($materialId: String!, $url: String!) {
    generateLinkPreview(
      generateLinkPreviewInput: { url: $url, materialId: $materialId }
    ) {
      title
      description
      imageUrl
      iframe
    }
  }
`);

export type LinkPreview = ResultOf<
  typeof generateLinkPreviewMutation
>['generateLinkPreview'];
